import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HasRoleDirective } from 'src/app/directives/has-role.directive';
import { TimeInputMaskDirective } from 'src/app/directives/time-input-mask-directive';



@NgModule({
  declarations: [HasRoleDirective, TimeInputMaskDirective],
  imports: [
    CommonModule
  ],
  exports:[HasRoleDirective, TimeInputMaskDirective]
})
export class CvvCommonModule { }
